<div class="lg-page">
  <div class="lg-container">

    <header class="lg-header">
      <span class="lg-brand">SEHYOG ACADEMY</span>
      <h1 class="lg-title">Terms &amp; Conditions</h1>
      <p class="lg-tagline">The terms that apply when you book a place, register for tuition, or use our website.</p>
      <p class="lg-meta">
        Effective date: {{ effectiveDate }}
        <span class="lg-dot">&bull;</span>
        Applies to: sehyog.co.uk and all associated booking, tuition and mock-test services
      </p>
      <div class="lg-rule"></div>
    </header>

    <section class="lg-section" *ngFor="let sec of sections">
      <h2 class="lg-heading">{{ sec.number }}. {{ sec.title }}</h2>

      <p class="lg-para" *ngFor="let p of sec.paragraphs" [innerHTML]="p"></p>

      <ul class="lg-bullets" *ngIf="sec.bullets && sec.bullets.length">
        <li *ngFor="let b of sec.bullets" [innerHTML]="b"></li>
      </ul>
    </section>

    <p class="lg-footnote">
      This page should be read alongside our Privacy Policy and our Payment &amp; Refund Policy.
    </p>

  </div>
</div>
